import React from 'react'
import { Panel } from 'src/components/app-ui'
import ZapierBuilder from './zapier-builder'
import useStyles from './styles'

const MAKE_LOGIN_URL = 'https://www.make.com/en/login'

const ZapierWordmark = ({ classes }) => (
  <span className={classes.wordmark}>
    <span className={classes.zapierMark}>_</span>zapier
  </span>
)

/** Integrations › Automations: Zapier / Make cards and the Zapier builder. */
const AutomationsView = () => {
  const classes = useStyles()

  return (
    <div className={classes.automations}>
      <div className={classes.intro}>
        Connect Zapier or Make to send learner events to thousands of other
        apps, with no code.
      </div>
      <div className={classes.cards}>
        <Panel className={classes.card}>
          <ZapierWordmark classes={classes} />
          <div className={classes.cardDesc}>
            Build Zaps that run when learners enroll, finish a course or earn a
            certificate.
          </div>
        </Panel>
        <Panel className={classes.card}>
          <span className={classes.wordmark}>
            <span className={classes.makeMark}>{'///'}</span>make
          </span>
          <div className={classes.cardDesc}>
            Design visual scenarios with branching, filters and multi-step
            logic.
          </div>
          {/* TODO(backend): there is no Make connection yet, so this opens the
              Make sign-in and the Connected / Manage / Disconnect state from
              the design can't be shown. */}
          <button
            type="button"
            className={classes.connect}
            onClick={() => window.open(MAKE_LOGIN_URL, '_blank')}
          >
            Connect
          </button>
        </Panel>
      </div>
      <Panel className={classes.builder}>
        <div className={classes.builderHead}>
          <ZapierWordmark classes={classes} />
          <span className={classes.cardDesc}>
            Build a Zap without leaving this page.
          </span>
        </div>
        <ZapierBuilder />
      </Panel>
    </div>
  )
}

export default AutomationsView
